module.exports = __webpack_public_path__ + "static/media/Onboarding.0d7efeed.png";